export const memoize = (fn)=>{
  const cache = new Map();
  const cached = function(val) {
    return cache.has(val) ? cache.get(val) : cache.set(val, fn.call(this, val)) && cache.get(val);
  };
  cached.cache = cache;
  return cached;
};
export function filememoizeAsync(fn) {
  const cache = new Map();
  const cached = async function(file, ...args) {
    let subcache = cache.get(file.parent.path);
    if (!subcache) {
      subcache = new Map();
      cache.set(file.parent.path, subcache);
    }
    const key = `${file.path}:${args.join(',')}`;
    let val = subcache.get(key);
    if (!val) {
      val = await fn.call(this, file, ...args);
      subcache.set(key, val);
    }
    return val;
  };
  cached.cache = cache;
  return cached;
}
//# sourceMappingURL=memoize.js.map